import { combineReducers } from 'redux';
import map from './map';
import itinerary from './itinerary';

export default combineReducers({
    map,
    itinerary
});